import './global';
import "./register-form";
import './on-this-page';
import './external-link';
import './read-more';
import './accordion';
import './listing-pages';
import './button-scroll-top';
import './header';
import './sliders';
import './in-page-alert';
import "./global-popup";
import './scroll-to-hash';
import './client-reports';


(function ($) {


  //======================================================================
  //multiple select
  setTimeout(function () {
    var multipleSelect = $('.select2-selection--multiple');
    multipleSelect.append('<span class="select2-selection__rendered">SELECT CATEGORY</span><span class="select2-selection__arrow"></span>');
  }, 200);

  //======================================================================


  //======================================================================
  //progress bar set percent
  var progressPercent = $('.progress-bar');
  var getPercent = progressPercent.attr('data-width');
  progressPercent.animate({
    width: getPercent + "%"
  }, 1000);
  //======================================================================



})(jQuery);




